import { useTranslationsContext } from 'store/translations';
import Arrow from 'assets/img/smooth-arrow-left.svg';
import './QuestsGuideOverlayContent.styl';
import { ReactNode, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import { useResize } from 'src/hooks';

interface QuestsGuideOverlayContentProps {
    navigation: ReactNode;
    isEnd?: boolean;
}

export const QuestsGuideOverlayContent = observer(({ navigation, isEnd }: QuestsGuideOverlayContentProps) => {
    const { translate } = useTranslationsContext();
    const { isMob } = useStoreContext();
    const { width } = useResize();
    const [left, setLeft] = useState(isMob ? 329 : 0);

    useLayoutEffect(() => {
        if (isMob) {
            const elem = document.querySelector('.quests-guide-overlay-navigation #quests .navigation-item-icon');
            if (elem) {
                setLeft(elem.getBoundingClientRect().left + 5);
            }
        }
    }, [width]);

    return (
        <div className="quests-guide-overlay">
            <div className="quests-guide-overlay-content" style={{ left: left ? `${left}px` : undefined }}>
                <div className="quests-guide-overlay-content-title">
                    {translate(isEnd ? 'collection.end.quests.overlay.text' : 'quests.guide.overlay.text')}
                </div>
                <img className="quests-guide-overlay-content-arrow" src={Arrow}></img>
            </div>
            <div className="quests-guide-overlay-navigation">{navigation}</div>
        </div>
    );
});
